import { BreadcrumbsClassKey } from '@material-ui/core/Breadcrumbs';
import { Theme } from '@material-ui/core/styles';

const MuiBreadcrumbs = (theme: Theme): Partial<Record<BreadcrumbsClassKey, unknown>> => ({
    li: {
        '& > a': {
            color: theme.palette.grey[500],
            cursor: 'pointer',
            letterSpacing: '0.194px',
            '&:hover': {
                fontWeight: 500,
                color: theme.palette.primary.main,
                textDecoration: 'none',
                letterSpacing: 0,
                '-webkit-text-stroke': `0.05px ${theme.palette.primary.main}`,
            },
            '&:active': {
                letterSpacing: 0,
            },
            '&:focus': {
                outlineOffset: '10px',
            },
            '&:focus-visible': {
                outlineOffset: '2px',
            },
        },
    },
});

export default MuiBreadcrumbs;
